import { useEffect, useState } from "react";

/**
 * useIsMobile — reactive to viewport width, matches Tailwind's `sm` bp.
 * Returns true when viewport is narrower than 640px.
 */
export function useIsMobile(bp = 640) {
  const query = `(max-width: ${bp - 1}px)`;
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia(query);
    const onChange = () => setIsMobile(mq.matches);
    // Older browsers use addListener/removeListener
    if (mq.addEventListener) {
      mq.addEventListener("change", onChange);
      return () => mq.removeEventListener("change", onChange);
    }
    mq.addListener(onChange);
    return () => mq.removeListener(onChange);
  }, [query]);

  return isMobile;
}
